import {
  HttpErrorResponse,
  type HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { parseStaffScopeDenyReason } from './staff-authz';
import { StaffAuthzService } from './staff-authz.service';

/**
 * 인가 거부(403 `staff-scope-denied:<reason>`)를 `StaffAuthzService.denial` 에 올려 앱 셸이 같은 안내를
 * 보이게 한다. 에러는 삼키지 않고 그대로 다시 던진다 — 호출한 화면이 자기 상태를 되돌릴 수 있어야 한다.
 * 401 은 `staffRedirectOn401Interceptor` 담당이라 여기서는 403 만 본다.
 */
export const staffPermissionDeniedInterceptor: HttpInterceptorFn = (req, next) => {
  const authz = inject(StaffAuthzService);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status === 403) {
        const reason = parseStaffScopeDenyReason(err.error);
        if (reason !== null) authz.reportDenied(reason);
      }
      return throwError(() => err);
    }),
  );
};
